import script from "./QuotationDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotationDetailView.vue?vue&type=script&setup=true&lang=js"

import "./QuotationDetailView.vue?vue&type=style&index=0&id=3e9cffbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e9cffbf"]])

export default __exports__